import { CategoryNode } from "./TicketCategoryPicker";

/** Qual opção cada um dos dois selects deve estar mostrando. */
export interface CategoryPick {
  rootId: number | null;
  subId: number | null;
}

/**
 * Traduz a **folha** gravada no chamado nos dois selects da tela.
 *
 * Derivar em vez de guardar dois estados é o ponto: com `rootId` e `subId` em estado próprio,
 * reabrir a tela de um chamado que já tem subcategoria mostraria o primeiro select vazio — e a
 * pessoa "corrigiria" a classificação sem querer ao salvar.
 *
 * Uma folha que não está no catálogo carregado (categoria desativada, catálogo filtrado) devolve
 * os dois nulos: é melhor o select aparecer vazio do que mostrar uma opção que não existe na
 * lista e sumir no primeiro clique.
 */
export function resolveCategoryPick(categories: CategoryNode[], value: number | null): CategoryPick {
  if (value == null) return { rootId: null, subId: null };

  const raiz = categories.find((c) => c.id === value);
  if (raiz) return { rootId: raiz.id, subId: null };

  const mae = categories.find((c) => (c.children ?? []).some((f) => f.id === value));
  return mae ? { rootId: mae.id, subId: value } : { rootId: null, subId: null };
}
